/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_View_Channel_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to view channels by default (excluding private channels)." |
*
* @param {Leveling_Perm_View_Channel_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_view_channel_hint = /** @type {((inputs?: Leveling_Perm_View_Channel_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_View_Channel_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам по умолчанию видеть каналы, кроме приватных.")
	return /** @type {LocalizedString} */ ("Allows members to view channels by default (excluding private channels).")
});